import React from "react";
import { useForm } from "react-hook-form";
                
type FormValues = {
	logo: FileList;
	brandColor: string;
	primary: string;
	secondary: string;
	heading: string;
	base: string;
	btn: string;
	btnText: string;
	btnSize: string;
	btnFont: string;
	headingSize: string;
	headingWeight: string;
	baseSize: string;
	headingFont: string;
	baseFont: string;
	loader: FileList;
};

const StylingInputs = () => {
	const { register, handleSubmit } = useForm<FormValues>();

	const onSubmit = (data: FormValues) => {
		// FileList cannot be logged directly → convert to file name
		const formatted = {
			...data,
			logo: data.logo?.[0]?.name,
			loader: data.loader?.[0]?.name,
		};
		console.log("✅ Submitted Data:", formatted);
	};

	const colors = [
		{ name: "brandColor", value: "#5932F3" },
		{ name: "primary", value: "#FFFFFF" },
		{ name: "secondary", value: "#D9D9D9" },
		{ name: "heading", value: "#E5E4E0" },
		{ name: "base", value: "#000000" },
		{ name: "btn", value: "#F9FAFC" },
		{ name: "btnText", value: "#0F172A" },
	];
	// React.useEffect(() => {
	// 	const iframe = document.getElementById("preview-frame") as HTMLIFrameElement;
	// 	const subscription = watch((data: any) => {
	// 		iframe?.contentWindow?.postMessage({ type: "STYLE_UPDATE", payload: data }, "https://staging.scan.swanvision.ai");
	// 	});

	// 	return () => subscription.unsubscribe();
	// }, [watch]);
	return (
		<form onSubmit={handleSubmit(onSubmit)} className="w-1/4 bg-white border border-gray-200 rounded-xl shadow-sm p-4 overflow-y-auto max-h-[90vh]">
			<h2 className="font-semibold text-gray-800 mb-4 flex items-center space-x-2">
				<svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-indigo-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
					<path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16" />
				</svg>
				<span>Appearance</span>
			</h2>

			<div className="space-y-5 text-sm">
				{/* Logo */}
				<div>
					<label className="font-mono text-gray-500">{"// Logo"}</label>
					<div className="mt-1">
						<input type="file" {...register("logo")} className="w-full text-xs text-gray-600 border rounded p-1 bg-gray-50" />
					</div>
				</div>

				{/* Colors */}
				<div>
					<label className="font-mono text-gray-500">{"// Colors"}</label>
					<div className="space-y-2 mt-1">
						{colors.map((color) => (
							<div key={color.name} className="flex justify-between items-center space-x-2">
								<span>{color.name}</span>
								<div className="flex items-center space-x-1">
									<input type="color" defaultValue={color.value} {...register(color.name as keyof FormValues)} className="w-8 h-6 border rounded" />
									<input type="text" defaultValue={color.value} {...register(color.name as keyof FormValues)} className="w-20 border rounded text-xs px-1 py-0.5 text-gray-700" />
								</div>
							</div>
						))}
					</div>
				</div>

				{/* Button */}
				<div>
					<label className="font-mono text-gray-500">{"// Button"}</label>
					<div className="space-y-2 mt-1">
						<div className="flex justify-between items-center">
							<span>btnSize</span>
							<select {...register("btnSize")} className="border rounded text-gray-700 text-xs px-2 py-1 bg-gray-50 w-28">
								<option>12px</option>
								<option defaultValue="14px">14px</option>
								<option>16px</option>
								<option>18px</option>
							</select>
						</div>

						<div className="flex justify-between items-center">
							<span>btnFont</span>
							<select {...register("btnFont")} className="border rounded text-gray-700 text-xs px-2 py-1 bg-gray-50 w-32">
								<option>Inter</option>
								<option>Poppins</option>
								<option>Roboto</option>
								<option>Open Sans</option>
								<option>Lato</option>
							</select>
						</div>
					</div>
				</div>

				{/* Typography */}
				<div>
					<label className="font-mono text-gray-500">{"// Typography"}</label>
					<div className="space-y-2 mt-1">
						{["headingSize", "headingWeight", "baseSize", "headingFont", "baseFont"].map((field) => (
							<div key={field} className="flex justify-between items-center">
								<span>{field}</span>
								<select {...register(field as keyof FormValues)} className="border rounded text-gray-700 text-xs px-2 py-1 bg-gray-50 w-32">
									<option>Inter</option>
									<option>Poppins</option>
									<option>Roboto</option>
									<option>Open Sans</option>
									<option>Lato</option>
								</select>
							</div>
						))}
					</div>
				</div>

				{/* Loader */}
				<div>
					<label className="font-mono text-gray-500">{"// Loader Logo"}</label>
					<div className="mt-1">
						<input type="file" {...register("loader")} className="w-full text-xs text-gray-600 border rounded p-1 bg-gray-50" />
					</div>
				</div>

				{/* ✅ Submit Button */}
				<button type="submit" className="w-full bg-indigo-600 hover:bg-indigo-700 text-white text-xs py-2 rounded-lg mt-4">
					Save Settings
				</button>
			</div>
		</form>
	);
};

export default StylingInputs;
